import { ServiceDeskArea } from '@tracking-lib/use-case-tracking-models/service-desk.tracking.model'

export interface FAQData {
    topics: FAQTopic[]
}

export enum FAQTopicKey {
    GENERAL = 'General',
    FIRST_STEPS = 'FirstSteps',
    GROUP_MANAGEMENT = 'GroupManagement',
}

export interface FAQTopic {
    topicKey: FAQTopicKey
    headlineTranslationKey: string
    sublineTranslationKey: string
    categories: FAQCategory[]
}

export interface FAQCategory {
    categoryKey: string
    categoryTranslationKey: string
    questions: FAQQuestion[]
}

export interface FAQQuestion {
    questionKey: string
    questionTranslationKey: string
    answerTranslationKey: string
    showInTeaser: boolean
}

export const TopicTrackingAreaMapping = {
    [FAQTopicKey.FIRST_STEPS]: ServiceDeskArea.detailPageFirstSteps,
    [FAQTopicKey.GENERAL]: ServiceDeskArea.detailPageGeneral,
    [FAQTopicKey.GROUP_MANAGEMENT]: ServiceDeskArea.detailPageGroupManagement,
}

export const getTrackingAreaForTopic = (topic: FAQTopicKey): ServiceDeskArea =>
    TopicTrackingAreaMapping[topic]
